"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_GERSRES = createSystem(
  defaultConfig,
  SYSTEM_COMMON,
  {
    theme: {
      tokens: {
        colors: {
          primary: {
            50: { value: "#F2FAF0" },
            100: { value: "#C9E9C3" },
            200: { value: "#98D58C" },
            300: { value: "#6BB75C" },
            400: { value: "#60A452" },
            500: { value: "#518A45" },
            600: { value: "#44753A" },
            700: { value: "#375E2F" },
            800: { value: "#2E4F28" },
            900: { value: "#21391D" },
          },
          secondary: {
            50: { value: "#FEF5F5" },
            100: { value: "#FAD8D8" },
            200: { value: "#F6B5B5" },
            300: { value: "#F18888" },
            400: { value: "#ED6B6B" },
            500: { value: "#E34141" },
            600: { value: "#C03737" },
            700: { value: "#9B2C2C" },
            800: { value: "#832525" },
            900: { value: "#601B1B" },
          },
        },
      },
    },
  },
);
